var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"justify-center flex py-20"},[_c('img',{attrs:{"src":"https://c.tenor.com/IHdlTRsmcS4AAAAC/404.gif","alt":"404"}})])}]

export { render, staticRenderFns }